<template>
    <div class="row">
        <table class="table-list">
            <thead class="sticky-thead">
                <tr>
                    <th>
                        <a class="table-sorting-cta" v-on:click="sortBy('name')" :class="sortDirectionCssClass('name')">
                            Variant
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th>
                        <a class="table-sorting-cta" v-on:click="sortBy('engineName')"
                           :class="sortDirectionCssClass('engineName')">
                            Model
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                    <th v-if="tableType == 'electric'">
                        <a class="table-sorting-cta" v-on:click="sortBy('batteryCapacityNet')"
                           :class="sortDirectionCssClass('batteryCapacityNet')">
                            Batterikapacitet
                            <br />
                            (Netto/Brutto)
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th v-if="tableType == 'diesel' || tableType == 'gasoline' || tableType == 'hybrid'">
                        <a class="table-sorting-cta" v-on:click="sortBy('gearName')"
                           :class="sortDirectionCssClass('gearName')">
                            Gear
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                    <th v-if="tableType == 'electric' || tableType == 'hybrid'">
                        <a class="table-sorting-cta" v-on:click="sortBy('electricRange')"
                           :class="sortDirectionCssClass('electricRange')">
                            Elektrisk
                            <br />
                            rækkevidde
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th v-if="tableType == 'hybrid'">
                        <a class="table-sorting-cta" v-on:click="sortBy('chargingSpeedAC')"
                           :class="sortDirectionCssClass('chargingSpeedAc')">
                            Ladeeffekt
                            <br />
                            op til (AC)
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th v-if="tableType == 'hybrid'">
                        <a class="table-sorting-cta" v-on:click="sortBy('chargingTimeAC')"
                           :class="sortDirectionCssClass('chargingTimeAc')">
                            Ladetid
                            <br />
                            (AC 0-100%)
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th class="align-right">
                        <a class="table-sorting-cta" v-on:click="sortBy('horsepower')"
                           :class="sortDirectionCssClass('horsepower')">
                            Ydelse
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th class="align-right"
                        v-if="tableType == 'diesel' || tableType == 'gasoline' || tableType == 'hybrid'">
                        <a class="table-sorting-cta" v-on:click="sortBy('kilometerPerLiter')"
                           :class="sortDirectionCssClass('kilometerPerLiter')">
                            Forbrug
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                    <th class="align-right" v-if="tableType == 'electric'">
                        <a class="table-sorting-cta" v-on:click="sortBy('kWhPer100Kilometer')"
                           :class="sortDirectionCssClass('kWhPer100Kilometer')">
                            Forbrug
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th v-if="tableType == 'electric'">
                        <a class="table-sorting-cta" v-on:click="sortBy('chargingSpeedDC')"
                           :class="sortDirectionCssClass('chargingSpeedDc')">
                            Ladeeffekt
                            <br />
                            op til (AC/DC)
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th v-if="tableType == 'electric'">
                        <a class="table-sorting-cta" v-on:click="sortBy('chargingTimeDC')"
                           :class="sortDirectionCssClass('chargingTimeDc')">
                            Ladetid
                            <br />
                            AC 0-100% /
                            <br />
                            DC 10-80%
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th>
                        <a class="table-sorting-cta"
                           v-on:click="sortBy('towingCapacity')"
                           :class="sortDirectionCssClass('towingCapacity')">
                            Maks.
                            <br />
                            anhænger-
                            <br />
                            vægt 12%
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th class="align-right"
                        v-if="tableType == 'diesel' || tableType == 'gasoline' || tableType == 'hybrid'">
                        <a class="table-sorting-cta" v-on:click="sortBy('co2')" :class="sortDirectionCssClass('co2')">
                            CO₂
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th>
                        <a class="table-sorting-cta" v-on:click="sortBy('energyTaxSemiAnnually')"
                           :class="sortDirectionCssClass('energyTaxSemiAnnually')">
                            Halvårlig
                            <br />
                            CO2-ejerafgift
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <th>
                        <a class="table-sorting-cta" v-on:click="sortBy('prices')"
                           :class="sortDirectionCssClass('prices')">
                            Beskatning
                            <br />
                            fra
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>

                    <!--<th  >

                    </th>-->
                </tr>
            </thead>
            <tbody>
                <tr v-for="carModel in table" :key="carModel.id">
                    <td>
                        {{ carModel.name }}
                        <a href="" class="rowlink"></a>
                    </td>

                    <td>
                        {{ carModel.engineName }}
                        <a href="" class="rowlink"></a>
                    </td>
                    <td v-if="tableType == 'electric'">
                        {{ carModel.batteryCapacityNet }} kWh / {{ carModel.batteryCapacityGross }} kWh
                        <a href="" class="rowlink"></a>
                    </td>

                    <td v-if="tableType == 'diesel' || tableType == 'gasoline' || tableType == 'hybrid'">
                        {{ carModel.gearAmount }} {{ carModel.gearName }}
                        <a href="" class="rowlink"></a>
                    </td>
                    <td v-if="tableType == 'electric' || tableType == 'hybrid'">
                        {{ carModel.electricRange }} km
                        <a href="" class="rowlink"></a>
                    </td>

                    <td v-if="tableType == 'hybrid'">
                        {{ new Intl.NumberFormat('da-DK').format(carModel.chargingSpeedAc) }} kW
                        <a href="" class="rowlink"></a>
                    </td>

                    <td v-if="tableType == 'hybrid'">
                        {{ carModel.chargingTimeAcString }}
                        <a href="" class="rowlink"></a>
                    </td>

                    <td class="align-right">
                        {{ carModel.horsepower }} hk
                        <a href="" class="rowlink"></a>
                    </td>

                    <td class="align-right"
                        v-if="tableType == 'diesel' || tableType == 'gasoline' || tableType == 'hybrid'">
                        {{ carModel.kilometerPerLiter }} km/l
                        <a href="" class="rowlink"></a>
                    </td>
                    <td class="align-right" v-if="tableType == 'electric'">
                        {{ new Intl.NumberFormat('da-DK').format(carModel.kWhPer100Kilometer) }} kWh/100km
                        <a href="" class="rowlink"></a>
                    </td>

                    <td v-if="tableType == 'electric'">
                        {{ carModel.chargingSpeedAC }} kW / {{ carModel.chargingSpeedDC}} kW
                        <a href="" class="rowlink"></a>
                    </td>

                    <td v-if="tableType == 'electric'">
                        {{ minutesToString(carModel.chargingTimeAC) }} / {{ minutesToString(carModel.chargingTimeDC)}}
                        <a href="" class="rowlink"></a>
                    </td>

                    <td>
                        {{ carModel.towingCapacity && carModel.towingCapacity.trailer12Percent ? formatThousand(carModel.towingCapacity.trailer12Percent) : '0' }} kg
                        <a href="" class="rowlink"></a>
                    </td>

                    <td class="align-right"
                        v-if="tableType == 'diesel' || tableType == 'gasoline' || tableType == 'hybrid'">
                        {{ carModel.co2 }} g/km
                        <a href="" class="rowlink"></a>
                        <svg width="46" height="16" class="icon" v-if="carModel.energyClass">
                            <use v-bind:href="'/ui/icons/energy-arrows.svg#_' + carModel.energyClass"></use>
                        </svg>
                    </td>

                    <td class="align-right">
                        {{ formatThousand(carModel.energyTaxSemiAnnually) }} kr.
                        <a href="" class="rowlink"></a>
                    </td>

                    <td class="align-right">
                        {{ formatThousand(getPriceIncludedVat(carModel.prices)) }} kr.
                        <a href="" class="rowlink"></a>
                    </td>

                    <!--<td class="align-right">
                        <a href="" class="rowlink"></a>
                        <a title="Sammenlign" class="rowsublink">
                            <svg width="21" height="20">
                                <use href="/ui/icons/custom-sprite.svg#feather-compare-arrows"></use>
                            </svg>
                        </a>
                    </td>-->
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="100" v-html="overviewTermsAndConditionsText"></td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
    import formatMixin from '../mixins/formatter.js';
    import _ from 'lodash';

    export default {
        name: 'model-details-tax-base-overview-table',
        mixins: [formatMixin],
        props: {
            tableType: {
                type: String,
                default: undefined
            },
            tableData: {
                type: Array,
                default: undefined
            },
            overviewTermsAndConditionsText: {
                type: String,
                default: undefined
            },
            initialSortKey: {
                type: String,
                default: 'name'
            }
        },
        data() {
            return {
                sortKey: this.$props.initialSortKey,
                reverseOrder: false
            }
        },
        computed: {
            table: function () {
                if (!this.$props.tableData) return undefined;

                const sortKey = this.$data.sortKey;
                const reverseOrder = this.$data.reverseOrder ? 'desc' : 'asc';

                const carTable = _.orderBy(
                    this.$props.tableData,
                    item => {
                        const val = item[sortKey];

                        if (sortKey === 'prices') {
                            const priceObj = val.find(p => p.priceType === "priceIncludedVat");
                            return priceObj ? priceObj.value : undefined;
                        } else if (sortKey === 'towingCapacity') {
                            return val.trailer12Percent;
                        }

                        return val;
                    },
                    [reverseOrder]
                );

                return carTable;
            },
        },
        methods: {
            sortBy: function (sortKey) {
                this.reverseOrder = (this.sortKey == sortKey) ? !this.reverseOrder : true;
                this.sortKey = sortKey;
            },
            sortDirectionCssClass: function (sortKey) {
                let cssClass = '';

                if (this.sortKey === sortKey) {
                    cssClass += 'is-selected';
                }

                if (this.sortKey === sortKey && !this.reverseOrder) {
                    cssClass += ' is-pointing-up';
                }

                return cssClass;
            },
            minutesToString(totalMinutes) {
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;
                let result = [];

                if (hours > 0) {
                    result.push(`${hours} t`);
                }
                if (minutes > 0) {
                    result.push(`${minutes} m`);
                }

                return result.join(' ');
            },
            getPriceIncludedVat(prices) {
                if (!prices) return 0;

                return prices.find(p => p.priceType === "priceIncludedVat").value;
            }
        }
    }
</script>